import React from "react";
import { Helmet } from "react-helmet";
import styled from "@emotion/styled";
import InnerContainerImageGradient from "@components/InnerContainerImageGradient";
import BuyMainHeader from "@components/BuyMainHeader";
import CardRow from "@components/CardRow";
import BuyPageMessage from "@components/BuyPageMessage";
import Resizer from "@hocs/Resizer";
import loadable from "@loadable/component";
import { useSelector } from "react-redux";

const BuyPageCardsHeader = loadable(() =>
  import(
    /* webpackChunkName: "BuyPageCardsHeader" */ "../components/BuyPageCardsHeader"
  )
);
const Dropdown = loadable(() =>
  import(/* webpackChunkName: "Dropdown" */ "../components/Dropdown")
);
const CategoriesContainerLargeScreens = loadable(() =>
  import(
    /* webpackChunkName: "CategoriesContainerLargeScreens" */ "../components/CategoriesContainerLargeScreens"
  )
);
const QuickBuyMobileButton = loadable(
  () =>
    import(
      /* webpackChunkName: "QuickBuyMobileButton" */ "../components/QuickBuyMobileButton"
    ),
  { ssr: false }
);
const BuyTabletButtons = loadable(() =>
  import(
    /* webpackChunkName: "BuyTabletButtons" */ "../components/BuyTabletButtons"
  )
);
const MainContent = styled.div`
  display: grid;
  grid-template-columns: 250px 1fr;
  margin-top: 40px;
  grid-gap: 30px;
  margin-bottom: 110px;
  @media (max-width: 950px) {
    grid-gap: 0px;
  }
  @media (max-width: 950px) {
    grid-gap: 0px;
  }
  @media (max-width: 767px) {
    display: block;
  }
`;

const CardsHeaderDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  @media (max-width: 500px) {
    grid-template-columns: 1.4fr 1fr;
    grid-gap: 15px;
  }
  @media (max-width: 440px) {
    grid-template-columns: 1.6fr 1fr;
  }
  @media (max-width: 375px) {
    grid-template-columns: 1.3fr 1fr;
  }
  @media (max-width: 340px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const DropdownContainerDiv = styled.div`
  width: 227px;
  justify-self: flex-end;
  @media (max-width: 500px) {
    width: auto;
    justify-self: flex-start;
  }
`;

const BuyPageMain = () => {
  const buyMainLogo = useSelector(state => state.logos.buyMainLogo);

  return (
    <div
      className={`mar-t-128-108 discount-buy-main-page-container orange-caret`}
    >
      <Helmet
        title={`Buy Gift Cards, Discounted Gift Cards Save up to 35% | CardCash`}
      />

      <Resizer
        components={[
          {
            component: () => <QuickBuyMobileButton setDisplay={"768px"} />,
            break: 1,
            maxBreak: 768
          }
        ]}
      />

      <div>
        <InnerContainerImageGradient />
        <BuyMainHeader
          setClassName={
            buyMainLogo
              ? "buy-header-category buy-header-category-no-opacity"
              : "buy-header-main-all-cards"
          }
          name={"Buy gift cards at a discount"}
          categorySaleImage={buyMainLogo ? buyMainLogo : false}
        />
        <MainContent className="main-container-page-width">
          <Resizer
            components={[
              {
                component: () => (
                  <CategoriesContainerLargeScreens
                    guaranteeText={"45-day guarantee"}
                  />
                ),
                break: 767,
                maxBreak: Number.MAX_SAFE_INTEGER
              }
            ]}
            defaultComponent={() => (
              <CategoriesContainerLargeScreens
                guaranteeText={"45-day guarantee"}
              />
            )}
          />

          <div>
            <Resizer
              components={[
                {
                  component: () => (
                    <BuyTabletButtons guaranteeText={"45-day guarantee"} />
                  ),
                  break: 1,
                  maxBreak: 768
                }
              ]}
              defaultComponent={() => (
                <BuyTabletButtons guaranteeText={"45-day guarantee"} />
              )}
            />

            <CardsHeaderDiv>
              <BuyPageCardsHeader page={"buy"} />
              <DropdownContainerDiv>
                <Dropdown />
              </DropdownContainerDiv>
            </CardsHeaderDiv>
            <BuyPageMessage />
            <CardRow />
          </div>
        </MainContent>
      </div>
    </div>
  );
};

export default BuyPageMain;
